var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v(" Name ")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.monster.name))
          ]),
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Source")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.monster.source))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Hits")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.hits))
          ]),
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Race")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.race))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Dis/Con")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.dismissControl))
          ]),
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Pattern")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.pattern))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Intelligence")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.intelligence))
          ]),
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Strikes For")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "4" } }, [
            _vm._v(_vm._s(_vm.strikesFor))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Immunities")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "10" } }, [
            _vm._v(_vm._s(_vm.immunities))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "font-weight-medium",
              attrs: { cols: "6", sm: "2" }
            },
            [_vm._v("Abilities")]
          ),
          _c("v-col", { attrs: { cols: "6", sm: "10" } }, [
            _vm._v(_vm._s(_vm.abilities))
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "float-right" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: { name: "readMonster", params: { id: _vm.monster.keyId } },
                title: _vm.monster.name
              }
            },
            [_vm._v(" See More... ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }